import moment from "moment";

export const isMagicLinkUserExpired = verificationSentOn => {
  if (!verificationSentOn) return false;

  const verificationMoment = moment.utc(verificationSentOn);

  return moment.utc().isAfter(verificationMoment);
};
